export const sek = (v) => `${Math.round(v || 0).toLocaleString('sv-SE')} kr`;

export const fmtDate = (v) => {
  if (!v) return '';
  const d = new Date(String(v).length <= 10 ? `${v}T12:00:00` : v);
  return isNaN(d) ? String(v) : d.toLocaleDateString('sv-SE', { day: 'numeric', month: 'short', timeZone: 'Europe/Stockholm' });
};

export const fmtDateTime = (v) => {
  const d = new Date(v);
  return isNaN(d) ? '' : d.toLocaleString('sv-SE', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Stockholm' });
};

export const PRIORITY = {
  low: { label: 'Låg', cls: 'bg-slate-100 text-slate-600', dot: 'bg-slate-300' },
  normal: { label: 'Normal', cls: 'bg-blue-50 text-blue-700', dot: 'bg-blue-400' },
  high: { label: 'Hög', cls: 'bg-orange-50 text-orange-700', dot: 'bg-orange-500' },
  urgent: { label: 'Akut', cls: 'bg-red-50 text-red-700', dot: 'bg-red-600' },
};

export const FOLLOW = {
  green: 'text-emerald-700 bg-emerald-50 border-emerald-200',
  yellow: 'text-amber-800 bg-amber-50 border-amber-300',
  red: 'text-red-700 bg-red-50 border-red-300',
};

export const NEXT_ACTIVITIES = [
  'Skicka första mejlet', 'Följ upp mejl', 'Ring kontaktperson', 'Boka demonstration', 'Genomför demonstration',
  'Skicka offert', 'Följ upp offert', 'Invänta beslut', 'Kontakta efter årsskiftet',
];

export const CONTACT_METHODS = ['E-post', 'Telefon', 'Möte', 'Videomöte', 'Mässa', 'Övrigt'];

export const QUICK_FILTERS = [
  { key: 'active', label: 'Alla aktiva' },
  { key: 'hot', label: 'Heta leads' },
  { key: 'today', label: 'Uppföljning idag' },
  { key: 'overdue', label: 'Försenade' },
  { key: 'waiting', label: 'Väntar på svar' },
  { key: 'meetings_to_book', label: 'Möten att boka' },
  { key: 'quotes_to_follow', label: 'Offerter att följa upp' },
  { key: 'paused', label: 'Pausade' },
];

export function tierPrice(pricing, n) {
  const tiers = [...(pricing?.sensor_tiers || [])].sort((a, b) => a.min - b.min);
  if (!n || !tiers.length) return 0;
  const t = tiers.find(x => n >= x.min && n <= x.max);
  return t ? t.price : n > tiers[tiers.length - 1].max ? tiers[tiers.length - 1].price : tiers[0].price;
}

export const ACTIVE = ['new', 'contacted', 'demo', 'quote_sent', 'negotiation'];

export function filterLeads(leads, kpis, f) {
  const q = (f.search || '').trim().toLowerCase();
  let ids = null;
  if (f.quick && f.quick !== 'active' && f.quick !== 'paused' && kpis) ids = new Set(kpis[f.quick] || []);
  return leads.filter(l => {
    if (f.quick === 'active' && !ACTIVE.includes(l.stage)) return false;
    if (f.quick === 'paused' && l.stage !== 'paused') return false;
    if (ids && !ids.has(l.id)) return false;
    if (q && ![l.school_name, l.municipality, l.contact_name, l.contact_email].some(v => (v || '').toLowerCase().includes(q))) return false;
    if (f.stage && l.stage !== f.stage) return false;
    if (f.priority && l.crm?.priority?.level !== f.priority) return false;
    if (f.owner && l.owner_id !== f.owner) return false;
    if (f.minSensors && (l.estimated_sensors || 0) < +f.minSensors) return false;
    if (f.minValue && (l.crm?.value?.first_year || 0) < +f.minValue) return false;
    if (f.followBefore && (!l.follow_up_date || l.follow_up_date > f.followBefore)) return false;
    return true;
  });
}
